/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Category of test
 */
export type DiagnosticProcedureBodyDtoCategoryOfTest =
  (typeof DiagnosticProcedureBodyDtoCategoryOfTest)[keyof typeof DiagnosticProcedureBodyDtoCategoryOfTest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiagnosticProcedureBodyDtoCategoryOfTest = {
  direct: 'direct',
  indirect: 'indirect',
  observation: 'observation',
  others: 'others',
} as const;
